import * as React from 'react';
import { Grid, GridColumn as Column, GridDetailRowProps } from '@progress/kendo-react-grid';

import { Code } from '../../models/Code';
import CodeService from '../../services/CodeService';
import { Row, Col } from 'reactstrap';
import * as ArrayUtils from "typescript-array-utils";
import { Formik, FieldArray, FieldArrayRenderProps, FormikContext } from 'formik';
import { TableCommandCell } from './TableCommandCell';
import { DragCell } from '../controls/GridUtils';
import { IGridRowModel } from './Utils';
import * as shortid from 'shortid';
import { ProductAttribute } from '../../models/ProductAttribute';
import * as GridColumnEditors from './GridColumnEditors';


type ProductCodeListState = {
    gridData: IGridRowModel[];
    activeItem?: IGridRowModel;
    selectedItem?: IGridRowModel;
    isLoading: boolean;
} 

class CodeGridModel extends Code implements IGridRowModel {
    _id: string; // client side generated
    inEdit: boolean;
    expanded: boolean;
    isSaving: boolean;

    public static Build(data: Code): CodeGridModel {

        const result: CodeGridModel = {
            ...data,
            expanded: false,
            inEdit: false,
            isSaving: false,
            _id: shortid.generate()
        };

        return result;
    }
}

class CodeList extends React.Component<GridDetailRowProps, ProductCodeListState>
{
    processModelForGrid = (data: Code[]) => {
        return (data || []).map((x) => CodeGridModel.Build(x)).sort((a, b) => a.SortOrder - b.SortOrder);
    }

    constructor(props: Readonly<GridDetailRowProps>) {
        super(props);


        this.state = {
            gridData: [],
            activeItem: undefined,
            selectedItem: undefined,
            isLoading: false
        }
    }

    componentDidMount() {

        this.loadData();
    }

    loadData = () => {
        this.setState({ isLoading: true }, async () => {

            var result = await CodeService.list((this.props.dataItem as ProductAttribute).AttributeId);

            if (!result.hasErrors) {
                this.setState({
                    gridData: this.processModelForGrid(result.value),
                    isLoading: false
                })
            }
        });
    }

    MyFormGrid = (props: FormGridProps) => <FormGrid {...props}
        onSaveRequest={(item: Code, gridData: Code[]) => {
            CodeService.save(item).then((x) => {

                if (!x.hasErrors) {
                    
                    let index = (gridData as any as Code[]).findIndex(x => x.Id === item.Id);

                    let updatedItem = CodeGridModel.Build(x.value);
                    (updatedItem as any as IGridRowModel)._id = (item as any as IGridRowModel)._id;

                    const newGridData = ArrayUtils.replace(gridData, index, updatedItem) as any as IGridRowModel[];
                    this.setState({
                        gridData: newGridData
                    });
                }

            });
        }}

        getOriginalItem={(item: IGridRowModel) => this.state.gridData.find((x) => x._id === item._id)}

    />

    render() {
        return <React.Fragment>
            <Row>
                <Col>                    
                    <Formik
                        enableReinitialize={true}
                        initialValues={{ items: this.state.gridData }}
                        onSubmit={(values) => {
                            console.log('formik submit', values);
                        }}
                    >

                        {({ values, dirty, submitForm, setFieldValue }) => {
                            return <FieldArray name="items"
                                component={this.MyFormGrid}
                            />

                        }}
                    </Formik>
                </Col>
            </Row>
        </React.Fragment>
    }
};

type FormGridProps = FieldArrayRenderProps & {
    onSaveRequest: (item: any, gridData: any[]) => void;
    getOriginalItem: (item: IGridRowModel) => IGridRowModel;
};

type FormGridState = {
    activeItem?: IGridRowModel,
    selectedItem?: IGridRowModel
    editedItem?: IGridRowModel
}

class FormGrid extends React.Component<FormGridProps, FormGridState>{

    static contextType = FormikContext;
    context!: React.ContextType<typeof FormikContext>;


    editField = "inEdit";
    CommandCell;

    constructor(props) {
        super(props);

        this.state = {
            activeItem: undefined,
            selectedItem: undefined,
            editedItem: undefined
        }

        this.CommandCell = TableCommandCell({
            edit: (dataItem: IGridRowModel) => {

                let index = this.getDataSource().findIndex(p => (p._id === dataItem._id));
                dataItem.inEdit = true;
                this.setState({ editedItem: dataItem }, () => { this.props.replace(index, dataItem); });
                
            },
            editModal: undefined,
            remove: undefined,//this.remove,
            add: (dataItem: IGridRowModel) => {
                /*let index = (this.props.value as IGridRowModel[]).findIndex(p => (p._id === dataItem._id));

                dataItem.inEdit = false;

                this.props.onReplace({ value: dataItem, index });*/
            },//this.add,
            discard: () => { /*this.context.formCtx.onFormReset()*/ }, //this.discard,
            update: (dataItem: IGridRowModel) => {
                this.props.onSaveRequest(dataItem, this.getDataSource());
            },
            cancel: (dataItem: IGridRowModel) => {
                var originalItem = this.props.getOriginalItem(dataItem);
                let index = this.getDataSource().findIndex(p => (p._id === dataItem._id));
                originalItem.inEdit = false;
                this.props.replace(index, originalItem);

            },
            editField: "inEdit",
            isNew: (dataItem: Code) => (dataItem.Id || '').length === 0,
            getStringRepresentation: (dataItem: Code) => dataItem.ShortDescription
        });

    }

    getDataSource = () => this.props.form.values[this.props.name] as IGridRowModel[];

    reorder = (dataItem: IGridRowModel) => {

        if (this.state.activeItem && (this.state.activeItem._id === dataItem._id)) {
            return;
        }

        //console.log('reorder', dataItem);

        let reorderedData = this.getDataSource();
        let nextIndex = reorderedData.findIndex(p => (p._id === this.state.activeItem._id));
        let prevIndex = reorderedData.findIndex(p => (p._id === dataItem._id));

        //console.log(`reorder: prev/next: ${prevIndex} > ${nextIndex}`, dataItem);
        this.props.move(prevIndex, nextIndex);
    }

    dragStart = (dataItem: IGridRowModel) => {

        this.setState({
            activeItem: dataItem
        });
    }

    dragEnd = (dataItem: IGridRowModel) => {
        //console.log('dragEnd', dataItem);

        let reorderedData = this.getDataSource();
        let nextIndex = reorderedData.findIndex(p => (p._id === this.state.activeItem._id));
        let prevIndex = reorderedData.findIndex(p => (p._id === dataItem._id));

        //console.log(`dragEnd: prev/next: ${prevIndex} > ${nextIndex}`, dataItem);

        if (nextIndex === prevIndex)
            return;


        let newSortOrder = 0;

        if (nextIndex === 0) {
            newSortOrder = (reorderedData[1] as any as Code).SortOrder - 100;
        } else {

            if (nextIndex === reorderedData.length - 1)
                newSortOrder = (reorderedData[reorderedData.length - 2] as any as Code).SortOrder + 100;
            else {
                let prevSort = (reorderedData[nextIndex - 1] as any as Code).SortOrder;
                const nextSort = (reorderedData[nextIndex + 1] as any as Code).SortOrder;

                if (prevSort === nextSort) {
                    prevSort = this.findLessThanGreaterThan(prevSort);
                }

                newSortOrder = (nextSort + prevSort) / 2;
            }
        }

        // save here the newSortOrder

        const itemToSave = this.state.activeItem as any as Code;

        itemToSave.SortOrder = newSortOrder;
        this.props.onSaveRequest(itemToSave, this.getDataSource());
    }

    findLessThanGreaterThan = (value: number) => {

        let ds = this.getDataSource();
        let result = (ds[0] as any as Code).SortOrder;

        for (var i = 1; i < ds.length; i++) {
            let newValue = (ds[i] as any as Code).SortOrder
            if (newValue < value && result < newValue)
                result = newValue;
        }

        if (result === value)
            result -= 100;

        return result;
    }

    MyDragCell = (props) => <DragCell<IGridRowModel> {...props}
        reorder={this.reorder}
        dragStart={this.dragStart}
        dragEnd={this.dragEnd}
    />

    render() {
        return <div>
            <Grid
                style={{ maxHeight: '500px' }}
                data={this.props.form.values["items"]}                
                onRowClick={(e) => {
                    this.setState({
                        selectedItem: (e.dataItem as CodeGridModel)
                    });
                }}    
                editField={this.editField}
            >
                <Column title="" width="40px" cell={this.MyDragCell} />
                <Column field="Name" title="Attribute Value" editable={false} />
                <Column field="Description" title="Long Description" cell={GridColumnEditors.TextColumn} />                
                <Column field="ShortDescription" title="Short Description" cell={GridColumnEditors.TextColumn} />
                <Column cell={this.CommandCell} width="200px" />
            </Grid>
        </div>
    }
}


export default CodeList;
